export interface UploadDraft {
  name: string;
  mime: string;
  contentBase64: string;
  size: number;
}

export const MAX_FILE_MB = 10;

/** Legge un file scelto dall'utente e lo prepara per l'invio al server (base64). */
export function readUpload(file: File): Promise<UploadDraft> {
  return new Promise((resolve, reject) => {
    if (file.size > MAX_FILE_MB * 1024 * 1024) {
      reject(new Error(`${file.name}: supera il limite di ${MAX_FILE_MB} MB`));
      return;
    }
    const r = new FileReader();
    r.onerror = () => reject(new Error(`Impossibile leggere ${file.name}`));
    r.onload = () => {
      const s = String(r.result);
      resolve({ name: file.name, mime: file.type || 'application/octet-stream', contentBase64: s.slice(s.indexOf(',') + 1), size: file.size });
    };
    r.readAsDataURL(file);
  });
}

export function sizeLabel(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

export function saveBlob(blob: Blob, name: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
